import { useSWR } from '@tiger/swr';
import security, { fixDataToLocal } from 'stores/security';
import { CustomerInfoType } from 'types/customer';
import API from 'utils/API';

export default function useCustomerInfo(customerId?: number) {
    const { currentCustomerId } = security;

    return useSWR<CustomerInfoType>(
        {
            url: API.CUSTOMER.customerInfo(),
            params: {
                customer_id: customerId || currentCustomerId
            }
        },
        {
            dataChain: (res: { data: CustomerInfoType }) => {
                const curCustomerInfo = fixDataToLocal(res.data);

                return curCustomerInfo;
            },
            onSuccess: data => {
                security.setCustomerInfo(data);
            }
        }
    );
}
